// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileSettingsPage__loaderWrapper--UZ2e {
    display: flex;
    align-items: center;
    justify-content: center;
}

.ProfileSettingsPage__information--bHzw {
    width: 100%;
    max-width: 630px;
}

.ProfileSettingsPage__information--bHzw .ProfileSettingsPage__buttonCancel--WRMA,
    .ProfileSettingsPage__information--bHzw .ProfileSettingsPage__buttonDelete--J7UO {
        padding: 9px 24px;
        letter-spacing: 0.05em;
        font-weight: 700;
        line-height: 24px;
        border-color: currentColor;
    }

@media screen and (max-width: 1023px) {

.ProfileSettingsPage__information--bHzw .ProfileSettingsPage__buttonCancel--WRMA,
    .ProfileSettingsPage__information--bHzw .ProfileSettingsPage__buttonDelete--J7UO {
            width: 100%
    }
        }

.ProfileSettingsPage__title--lGra {
    font-size: 30px;
    line-height: 44px;
    font-weight: 700;
    color: var(--secondary-color);
    margin-bottom: 32px;
}

.ProfileSettingsPage__box--jBAT {
    border: 1px solid var(--obscure-color);
    padding: 32px;
    margin-bottom: 24px;
    border-radius: 6px;
}

.ProfileSettingsPage__fieldName--j87l,
.ProfileSettingsPage__subtitle--GkKY {
    font-size: 22px;
    line-height: 32px;
    font-weight: 700;
    color: var(--secondary-color);
    margin-bottom: 16px;
}

.ProfileSettingsPage__fieldValue--tk9y {
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    color: var(--secondary-color);
}

.ProfileSettingsPage__subscriptionBlock--Qh8n {
    color: var(--tertiary-color);
}

.ProfileSettingsPage__subscriptionBlockTitle--enfD {
    font-size: 22px;
    line-height: 32px;
    font-weight: 700;
    color: var(--secondary-color);
    margin-bottom: 16px;
}

.ProfileSettingsPage__subscriptionList--OtRv {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.ProfileSettingsPage__subscriptionItem--iss2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2px;
    padding: 16px 12px;
    border: 1px solid var(--obscure-color);
    border-radius: 6px;
    font-size: 14px;
    line-height: 20px;
}

.ProfileSettingsPage__subscriptionItem--iss2 > span:first-child {
        font-weight: 600;
    }

.ProfileSettingsPage__subscriptionItem--iss2 > span:last-child {
        font-weight: 400;
    }

.ProfileSettingsPage__subscriptionItem--iss2 > span:last-child.ProfileSettingsPage__active--KHPt {
            color: var(--success-color);
            font-weight: 600;
        }

.ProfileSettingsPage__subscriptionItem--iss2 > span:last-child.ProfileSettingsPage__canceled--acbG {
            color: var(--warning-color);
            font-weight: 600;
        }

.ProfileSettingsPage__subscriptionCancel--loPt {
    margin-top: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
}

@media screen and (max-width: 518px) {

.ProfileSettingsPage__subscriptionCancel--loPt {
        flex-direction: column;
        gap: 4px
}

        .ProfileSettingsPage__subscriptionCancel--loPt > button {
            width: 100%;
        }
    }

.ProfileSettingsPage__smallNotice--GAIY {
    margin-bottom: 0;
}

@media screen and (min-width: 1024px) {

.ProfileSettingsPage__modal--elOF.ProfileSettingsPage__preCancelSubscriptionModal--fRF3 {
        width: 630px;
        height: 224px
}
    }

@media screen and (min-width: 1024px) {

.ProfileSettingsPage__modal--elOF.ProfileSettingsPage__canceledSubscriptionModal--d00C {
        width: 630px;
        height: 232px
}
    }

@media screen and (min-width: 1024px) {

.ProfileSettingsPage__modal--elOF.ProfileSettingsPage__preDeleteAccountModal--iSYu {
        width: 630px;
        height: 368px
}
    }

.ProfileSettingsPage__modalDescription--m8we {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: var(--secondary-color);
}

.ProfileSettingsPage__modalDescription--m8we > strong {
        font-weight: 600;
    }`, "",{"version":3,"sources":["webpack://./src/ui/pages/ProfileSettingsPage/ProfileSettingsPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gBAAgB;AAcpB;;AAZI;;QAEI,iBAAiB;QACjB,sBAAsB;QACtB,gBAAgB;QAChB,iBAAiB;QACjB,0BAA0B;IAK9B;;AAHI;;AARJ;;YASQ;IAER;QADI;;AAIR;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,kBAAkB;IAClB,sCAAsC;IACtC,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AAmBrB;;AAjBI;QACI,gBAAgB;IACpB;;AAEA;QACI,gBAAgB;IAWpB;;AATI;YACI,2BAA2B;YAC3B,gBAAgB;QACpB;;AAEA;YACI,2BAA2B;YAC3B,gBAAgB;QACpB;;AAIR;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;AAUb;;AARI;;AANJ;QAOQ,sBAAsB;QACtB;AAMR;;QAJQ;YACI,WAAW;QACf;IACJ;;AAGJ;IACI,gBAAgB;AACpB;;AAGI;;AADJ;QAEQ,YAAY;QACZ;AAER;IADI;;AAIA;;AADJ;QAEQ,YAAY;QACZ;AAER;IADI;;AAIA;;AADJ;QAEQ,YAAY;QACZ;AAER;IADI;;AAGJ;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AAKjC;;AAHI;QACI,gBAAgB;IACpB","sourcesContent":[".loaderWrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.information {\n    width: 100%;\n    max-width: 630px;\n\n    .buttonCancel,\n    .buttonDelete {\n        padding: 9px 24px;\n        letter-spacing: 0.05em;\n        font-weight: 700;\n        line-height: 24px;\n        border-color: currentColor;\n\n        @media (--mobile) {\n            width: 100%;\n        }\n    }\n}\n\n.title {\n    font-size: 30px;\n    line-height: 44px;\n    font-weight: 700;\n    color: var(--secondary-color);\n    margin-bottom: 32px;\n}\n\n.box {\n    border: 1px solid var(--obscure-color);\n    padding: 32px;\n    margin-bottom: 24px;\n    border-radius: 6px;\n}\n\n.fieldName,\n.subtitle {\n    font-size: 22px;\n    line-height: 32px;\n    font-weight: 700;\n    color: var(--secondary-color);\n    margin-bottom: 16px;\n}\n\n.fieldValue {\n    font-size: 14px;\n    line-height: 20px;\n    font-weight: 400;\n    color: var(--secondary-color);\n}\n\n.subscriptionBlock {\n    color: var(--tertiary-color);\n}\n\n.subscriptionBlockTitle {\n    font-size: 22px;\n    line-height: 32px;\n    font-weight: 700;\n    color: var(--secondary-color);\n    margin-bottom: 16px;\n}\n\n.subscriptionList {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.subscriptionItem {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 2px;\n    padding: 16px 12px;\n    border: 1px solid var(--obscure-color);\n    border-radius: 6px;\n    font-size: 14px;\n    line-height: 20px;\n\n    > span:first-child {\n        font-weight: 600;\n    }\n\n    > span:last-child {\n        font-weight: 400;\n\n        &.active {\n            color: var(--success-color);\n            font-weight: 600;\n        }\n\n        &.canceled {\n            color: var(--warning-color);\n            font-weight: 600;\n        }\n    }\n}\n\n.subscriptionCancel {\n    margin-top: 16px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    @media (--tiny-only) {\n        flex-direction: column;\n        gap: 4px;\n\n        > button {\n            width: 100%;\n        }\n    }\n}\n\n.smallNotice {\n    margin-bottom: 0;\n}\n\n.modal.preCancelSubscriptionModal {\n    @media (--large) {\n        width: 630px;\n        height: 224px;\n    }\n}\n\n.modal.canceledSubscriptionModal {\n    @media (--large) {\n        width: 630px;\n        height: 232px;\n    }\n}\n\n.modal.preDeleteAccountModal {\n    @media (--large) {\n        width: 630px;\n        height: 368px;\n    }\n}\n\n.modalDescription {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    color: var(--secondary-color);\n\n    > strong {\n        font-weight: 600;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loaderWrapper": `ProfileSettingsPage__loaderWrapper--UZ2e`,
	"information": `ProfileSettingsPage__information--bHzw`,
	"buttonCancel": `ProfileSettingsPage__buttonCancel--WRMA`,
	"buttonDelete": `ProfileSettingsPage__buttonDelete--J7UO`,
	"title": `ProfileSettingsPage__title--lGra`,
	"box": `ProfileSettingsPage__box--jBAT`,
	"fieldName": `ProfileSettingsPage__fieldName--j87l`,
	"subtitle": `ProfileSettingsPage__subtitle--GkKY`,
	"fieldValue": `ProfileSettingsPage__fieldValue--tk9y`,
	"subscriptionBlock": `ProfileSettingsPage__subscriptionBlock--Qh8n`,
	"subscriptionBlockTitle": `ProfileSettingsPage__subscriptionBlockTitle--enfD`,
	"subscriptionList": `ProfileSettingsPage__subscriptionList--OtRv`,
	"subscriptionItem": `ProfileSettingsPage__subscriptionItem--iss2`,
	"active": `ProfileSettingsPage__active--KHPt`,
	"canceled": `ProfileSettingsPage__canceled--acbG`,
	"subscriptionCancel": `ProfileSettingsPage__subscriptionCancel--loPt`,
	"smallNotice": `ProfileSettingsPage__smallNotice--GAIY`,
	"modal": `ProfileSettingsPage__modal--elOF`,
	"preCancelSubscriptionModal": `ProfileSettingsPage__preCancelSubscriptionModal--fRF3`,
	"canceledSubscriptionModal": `ProfileSettingsPage__canceledSubscriptionModal--d00C`,
	"preDeleteAccountModal": `ProfileSettingsPage__preDeleteAccountModal--iSYu`,
	"modalDescription": `ProfileSettingsPage__modalDescription--m8we`
};
export default ___CSS_LOADER_EXPORT___;
